import { render, staticRenderFns } from "./ServerView.vue?vue&type=template&id=5ba95910"
import script from "./ServerView.vue?vue&type=script&lang=js"
export * from "./ServerView.vue?vue&type=script&lang=js"
import style0 from "./ServerView.vue?vue&type=style&index=0&id=5ba95910&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports